import cn from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import RequiredToggle from "~/components/formConfiguration/components/RequiredToggle";
import DeleteIcon, { deleteIconCompanionStyles } from "../../ui/DeleteIcon";
import IconListMove from "../icon/IconListMove";
import IconLock from "../icon/IconLock";
import RatingTooltip from "./components/RatingTooltip";
import ReviewTooltip from "./components/ReviewTooltip";

export default function FormField({
  field,
  sortable,
  onSwitchState,
  onDelete,
  hoverActive,
  withElementManagement,
  url,
}) {
  const styles = deleteIconCompanionStyles();

  const handleSwitchState = (on) => {
    onSwitchState(field.id, on);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    onDelete(field.id);
  };

  const reviewField =
    field.id === "review" || field.id === "facilitator_review";
  const ratingField =
    field.id === "rating" || field.id === "facilitator_impression";

  return (
    <div
      className={cn(
        "grid grid-cols-6 gap-6 py-3 px-4 rounded-md",
        styles.removableLine,
        { "hover:bg-blue-table-hover": hoverActive },
        { "border-red border-2 border-opacity-50": field.highlightError }
      )}
    >
      <div className="col-span-3">
        <label
          className={cn("flex mt-0.5", {
            "text-gray-dark": field.locked,
          })}
        >
          <span className="flex-none mr-1 text-gray-dark">
            {sortable && (
              <IconListMove className="sort-handle hover:cursor-pointer" />
            )}
            {!sortable && <IconLock />}
          </span>
          <span>
            {field.label} {reviewField && <ReviewTooltip />}{" "}
            {ratingField && <RatingTooltip />}
            {field.editable && withElementManagement && (
              <>
                {" "}
                &bull;{" "}
                <Link
                  to={`${url}/field/${field.id}`}
                  className="text-blue font-normal"
                >
                  Edit
                </Link>
              </>
            )}
          </span>
        </label>
      </div>
      <div className="col-span-3 flex mt-0.5 justify-between">
        <span>
          <RequiredToggle
            on={field.required}
            active={!field.locked}
            handleStateSwitch={handleSwitchState}
          />
        </span>
        {!field.locked && (
          <DeleteIcon
            title="Delete field"
            onDelete={handleDelete}
            iconClassName="ml-2"
          />
        )}
      </div>
    </div>
  );
}
